// Code generated by typegen/main.go. DO NOT EDIT.

import type { AppFamilyName } from "./typesGenerated";

// From codersdk.AppFamilyDisplayNames.
export const appFamilyDisplayNames: Record<AppFamilyName, string> = {
	jetbrains: "JetBrains",
	port_forwarding: "Port Forwarding",
	reconnecting_pty: "Web Terminal",
	sftp: "SFTP",
	ssh: "SSH",
	unknown: "Unknown",
	vscode: "VS Code Family",
};
